<div class="order">
  <a class="order__back" *ngIf="calculation" [routerLink]="['/calculations', calculation.id, 'overview']">
    <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M12 4l-6 6 6 6"/></svg>
    {{ t('calcSections.overview', 'Стоимость поставки') }}
  </a>

  <header class="order__head">
    <h1>
      {{ t('orderSupport.requestTitle', 'Заявка на сопровождение') }}
      <span class="order__number" *ngIf="calculation">№ {{ requestNumber }}</span>
    </h1>
    <p>{{ t('orderSupport.lead', 'Bilload возьмёт поставку под контроль — от документов до выпуска товаров на таможне.') }}</p>
  </header>

  <p class="order__state" *ngIf="loading">{{ t('orderSupport.loading', 'Загрузка…') }}</p>

  <ng-container *ngIf="!loading && calculation">
    <!-- ── Сводка расчёта ──────────────────────────────────────────────── -->
    <section class="order-card">
      <h2>{{ t('orderSupport.summaryTitle', 'Ваш расчёт') }}</h2>
      <ul class="order-rows">
        <li>
          <span>{{ t('orderSupport.calcNumber', 'Номер расчёта') }}</span>
          <strong>№ {{ calculation.id }}<ng-container *ngIf="calculation.createdAt"> {{ t('orderSupport.dateFrom', 'от') }} {{ calculation.createdAt | date:'dd.MM.yyyy' }}</ng-container></strong>
        </li>
        <li>
          <span>{{ t('orderSupport.goodsValue', 'Общая стоимость товаров') }}</span>
          <strong>{{ invoiceValue }}</strong>
        </li>
      </ul>
    </section>

    <!-- ── Что входит и цена ────────────────────────────────────────────── -->
    <section class="order-card">
      <h2>{{ t('orderSupport.includesTitle', 'Что входит в сопровождение') }}</h2>
      <ul class="order-services">
        <li *ngFor="let s of services">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.5 3.5L15 7"/></svg>
          <span>{{ t(s.key, s.fallback) }}</span>
        </li>
      </ul>
      <div class="order-price">
        <span>{{ t('calcSections.billoadServices', 'Услуги Bilload') }}</span>
        <strong>{{ fmt(90000) }} ₸ <small>{{ t('orderSupport.noVat', 'без НДС') }}</small></strong>
      </div>
      <p class="order-card__note">{{ t('orderSupport.priceNote', 'Разрешительные документы, услуги СВХ и страхование оплачиваются отдельно. Точную стоимость согласуем с вами до начала работ.') }}</p>
    </section>

    <!-- ── Вопросы — менеджеру в WhatsApp, сообщение уже с номером заявки ── -->
    <section class="order-card order-help">
      <div class="order-help__text">
        <h2>{{ t('orderSupport.helpTitle', 'Есть вопросы?') }}</h2>
        <p>{{ t('orderSupport.helpText', 'Менеджер Bilload ответит в WhatsApp и поможет с заявкой.') }}</p>
      </div>
      <a class="order-help__wa" [href]="whatsappLink" target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z"/><path d="M8.8 8.6c.2-.5.5-.5.8-.5h.5c.2 0 .4.1.5.4l.7 1.7c.1.2 0 .4-.1.6l-.5.6c-.1.1-.2.3 0 .5.3.6.8 1.2 1.4 1.7.6.5 1.2.8 1.8 1 .2.1.4 0 .5-.1l.6-.7c.2-.2.4-.2.6-.1l1.6.8c.2.1.4.2.4.4 0 .3 0 .9-.4 1.3-.4.5-1.3.9-2.1.8-1-.1-2.4-.6-3.8-1.8-1.6-1.4-2.4-2.9-2.6-3.8-.2-.9.1-1.5.5-1.8z"/></svg>
        {{ t('orderSupport.helpButton', 'Написать в WhatsApp') }}
      </a>
    </section>

    <!-- ── Согласие и подтверждение ─────────────────────────────────────── -->
    <section class="order-confirm">
      <label class="order-confirm__agree">
        <input type="checkbox" [(ngModel)]="agreed" />
        <span>{{ t('orderSupport.agree', 'Понимаю, что сопровождение — платная услуга стоимостью {amount} ₸ без НДС.').replace('{amount}', fmt(90000)) }}</span>
      </label>
      <p class="order-confirm__next" *ngIf="isPublicUser">
        {{ t('orderSupport.nextStep', 'Дальше укажете данные компании — и откроется полный доступ к платформе: заявки экспедиторам, документы с поставщиком, сделки и чат.') }}
      </p>
      <button type="button" class="btn btn--primary btn--wide" [disabled]="!agreed" (click)="confirm()">
        {{ t('orderSupport.confirm', 'Подтвердить заявку') }}
      </button>
    </section>
  </ng-container>

  <app-upgrade-to-cargo-owner-modal
    *ngIf="showUpgrade"
    (upgraded)="onUpgraded()"
    (cancel)="showUpgrade = false"
  ></app-upgrade-to-cargo-owner-modal>

  <p class="order__state order__state--error" *ngIf="!loading && !calculation && error" role="alert">{{ error }}</p>
</div>
